import React, { useState } from 'react';
import Footer from '../../../components/Footer';
import VegIcon from '../../../components/VegIcon';
import OffersRenderer from '../../../components/OffersRenderer';
import './ModernChic.css';

import DEFAULT_LOGO from '../../../assets/defaults/logo-default.jpg';
import DEFAULT_BG from '../../../assets/defaults/bg-default.jpg';
import DEFAULT_ITEM from '../../../assets/defaults/item-default.jpg';

const ModernChic = ({ data }) => {
	const restaurant = data?.restaurant || {};
	const menus = data?.menus || [];
	const [activeMenuId, setActiveMenuId] = useState(menus[0]?.id);
	const [selectedItem, setSelectedItem] = useState(null);

	const activeMenu = menus.find(m => m.id === activeMenuId) || menus[0];

	if (!data) return <div>Loading...</div>;

	return (
		<div className="modern-chic-container">
			<header className="chic-header" style={{
				backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.9)), url(${restaurant.backgroundImageUrl || DEFAULT_BG})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center'
			}}>
				<div className="chic-header-content">
					<img src={restaurant.logoUrl || DEFAULT_LOGO} alt="Logo" className="chic-logo" />
					<h1 title={restaurant.name}>{restaurant.name || 'Restaurant'}</h1>
					<p className="chic-tagline" title={restaurant.description}>{restaurant.description || ''}</p>
					<div className="chic-info-badges">
						{restaurant.phoneNumber && <span>📞 {restaurant.phoneNumber}</span>}
						{restaurant.address && <span>📍 {restaurant.address}</span>}
					</div>
				</div>
			</header>

			{/* Offers / Notes */}
			<OffersRenderer offers={data?.offers} />

			{/* Menu Navigation Pills */}
			{menus.length > 1 && (
				<div className="chic-nav-container">
					<nav className="chic-menu-nav">
						{menus.map(menu => (
							<button
								key={menu.id}
								className={`chic-nav-pill ${activeMenuId === menu.id ? 'active' : ''}`}
								onClick={() => setActiveMenuId(menu.id)}
							>
								{menu.name}
							</button>
						))}
					</nav>
				</div>
			)}

			<main className="chic-main">
				{activeMenu ? (
					<div className="chic-menu-wrapper">
						<h2 className="chic-menu-title">{activeMenu.name}</h2>

						{activeMenu.categories?.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)).map(category => (
							<section key={category.id} className="chic-category">
								<h3 className="chic-cat-title">{category.name}</h3>
								<div className="chic-grid">
									{category.items?.map(item => (
										<ChicItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
									))}
								</div>
							</section>
						))}

						{activeMenu.uncategorizedItems?.length > 0 && (
							<section className="chic-category">
								<h3 className="chic-cat-title">More Goodies</h3>
								<div className="chic-grid">
									{activeMenu.uncategorizedItems.map(item => (
										<ChicItem key={item.id} item={item} onClick={() => setSelectedItem(item)} />
									))}
								</div>
							</section>
						)}
					</div>
				) : (
					<div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
						No menus available.
					</div>
				)}
			</main>

			{selectedItem && (
				<div className="chic-modal-overlay" onClick={() => setSelectedItem(null)}>
					<div className="chic-modal" onClick={e => e.stopPropagation()}>
						<button className="chic-modal-close" onClick={() => setSelectedItem(null)}>✕</button>
						<div className="chic-modal-img">
							<img src={selectedItem.imageUrl || DEFAULT_ITEM} alt={selectedItem.name} />
						</div>
						<div className="chic-modal-body">
							<h3>{selectedItem.name}</h3>
							<p className="modal-price">₹{(selectedItem.price || 0).toLocaleString()}</p>
							<p className="modal-desc">{selectedItem.description}</p>

							<div className="chic-modal-variants">
								<h4>Customizations</h4>
								{selectedItem.variants?.filter(v => v.isActive).map(v => (
									<div key={v.id} className="chic-v-row">
										<span>{v.name}</span>
										<span className="chic-v-price">
											{v.price > 0 ? `₹${v.price.toLocaleString()}` : 'Included'}
										</span>
									</div>
								))}
								{(!selectedItem.variants || selectedItem.variants.filter(v => v.isActive).length === 0) && (
									<p className="no-variants">No customizations available.</p>
								)}
							</div>
						</div>
					</div>
				</div>
			)}

			<Footer />
		</div>
	);
};

const ChicItem = ({ item, onClick }) => {
	if (!item) return null;

	return (
		<div className={`chic-card ${!item.isAvailable ? 'unavailable' : ''}`} onClick={onClick} style={{ cursor: 'pointer' }}>
			<div className="chic-card-image">
				<img src={item.imageUrl || DEFAULT_ITEM} alt={item.name} className="chic-img" />
				<div className="chic-price-tag">₹{(item.price || 0).toLocaleString()}</div>

				{/* Tags on Image */}
				{item.tags && item.tags.length > 0 && (
					<div className="chic-tags-overlay">
						{item.tags.map(tag => (
							<span key={tag} className="chic-tag-badge">{tag}</span>
						))}
					</div>
				)}
			</div>
			<div className="chic-card-content">
				<div className="chic-item-header">
					{(item.isVeg !== undefined && item.isVeg !== null) && (
						<span className={`chic-veg-badge ${item.isVeg ? 'veg' : 'nonveg'}`}>
							<span className="chic-veg-dot"></span>
						</span>
					)}
					<h4 className="chic-item-name" title={item.name}>{item.name}</h4>
				</div>
				<p className="chic-item-desc" title={item.description}>{item.description}</p>
			</div>
		</div>
	);
};

export default ModernChic;
